import { onBeforeUnmount, onMounted } from '@vue/composition-api'
import useAppConfig from '@core/@app-config/useAppConfig'
import { storeToRefs } from 'pinia'
import useUserStore from '@/store/user'

export default function useToggleThemeShortcut() {
  const { isLoggedIn } = storeToRefs(useUserStore())
  const { isDark } = useAppConfig()

  const handleKeyDown = event => {
    if (isLoggedIn.value && event.altKey && event.key === 't') {
      isDark.value = !isDark.value
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyDown)
  })
}
